/**
 * Creates a typed instance of an enum-like class whose constructor
 * copies keys from the given literals object onto itself.
 *
 * This factory function acts as a type-level cast so that TypeScript
 * understands the dynamic properties set by the constructor.
 *
 * Usage: In each enum file, create a typed wrapper that specifies
 * the entry type and enum class, then calls createEnum internally.
 *
 * @template {Record<string, any>} T
 * @template {new (literals: T) => any} C
 * @param {C} EnumClass
 * @param {T} enumLiterals
 * @returns {InstanceType<C>}
 */
export function createEnum(EnumClass, enumLiterals) {
  return /** @type {any} */ (new EnumClass(enumLiterals));
}
